import T from './table'
import ProductTable from './elements'
import { Link } from '@uswitch/ev-core/react'

import { getValue } from './utils'

import sw from '@uswitch/ev-utils/switch'
import { path } from '@uswitch/ev-utils/obj'

const CellFormatter = sw({
  default: ({ cell, data }) => (
    // eslint-disable-next-line react/jsx-pascal-case
    <ProductTable.text.Value
      value={getValue(cell.value, data)}
      unit={getValue(cell.unit, data)}
      subscript={getValue(cell.subscript, data)}
    />
  ),
})

const HTMLCell = sw({
  'cells.Split': ({ cell, data, key }) => (
    <For each='content' of={cell.contents} index='j'>
      {HTMLCell(content.type, { cell: content, data, key: `${key}-${j}` })}
    </For>
  ),

  'cells.Content': ({ cell, data, key }) => (
    <T.td key={key}>{CellFormatter(cell.content.type, { cell: cell.content, data })}</T.td>
  ),

  default: null,
})

const HTMLHeading = sw({
  'cells.Split': ({ cell, data, key }) => (
    <For each='content' of={cell.contents} index='j'>
      {HTMLHeading(content.type, { cell: content, data, key: `${key}-${j}` })}
    </For>
  ),

  'cells.Content': ({ cell, key }) => <T.th key={key}>{path(['heading', 'value'], cell)}</T.th>,

  default: null,
})

const ProductTableHtml = ({ data, header = {}, grid = { contents: [] } }) => (
  <T.wrap>
    <T.tr>
      <T.th>Product name</T.th>
      <For index='key' each='cell' of={grid.contents}>
        {HTMLHeading(cell.type, { key, cell })}
      </For>
    </T.tr>

    <For index='id' each='product' of={data}>
      <T.tr key={id}>
        <T.td>
          <Choose>
            <When condition={grid.contents.find(({ id }) => id === 'cells.Cta')}>
              <Link
                href={getValue(
                  grid.contents.find(({ id }) => id === 'cells.Cta').primary.href,
                  product,
                )}
              >
                {getValue(header.title, product)}
              </Link>
            </When>
            <Otherwise>{getValue(header.title, product)}</Otherwise>
          </Choose>
        </T.td>

        <For index='key' each='cell' of={grid.contents}>
          {HTMLCell(cell.type, { key, cell, data: product })}
        </For>

        <For index='key' each='cell' of={grid.contents.filter(({ id }) => id === 'cells.Cta')}>
          <T.td key={key}></T.td>
        </For>
      </T.tr>
    </For>
  </T.wrap>
)

export default ProductTableHtml
